// deps
import React, { memo } from "react";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

// defs
import { PaymentFailureResponse } from "@swiggy-private/payment-types";

// constants
import { AUTOPAY_ASSETS, TEXTS } from "@payment-client/components/autopay-payment-failure-screen/constants";

// style components
import { ImageContainer, CurrentStateText, TimelineContainer, TimelineImage, TimelineContent } from "./styles";

interface AutopayTimelineContentProps {
    show: boolean;
    timelineText?: PaymentFailureResponse["autopayTimelineText"];
}

function AutopayTimelineContent({ show, timelineText }: AutopayTimelineContentProps) {
    const { CURRENT_STATE_TEXT, NEXT_STATE_TEXT, NEXT_STATE_ALTERNATE_TEXT } = TEXTS.TIMELINE;
    const {
        current = CURRENT_STATE_TEXT,
        next = NEXT_STATE_TEXT,
        nextAlt = NEXT_STATE_ALTERNATE_TEXT,
    } = timelineText || {};

    return (
        <TimelineContainer data-testid={AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS.CONSENT_TIMELINE} show={show}>
            <ImageContainer>
                <TimelineImage cloudinaryId={AUTOPAY_ASSETS.TIMELINE_IMG} />
            </ImageContainer>
            <TimelineContent>
                <CurrentStateText variant="V2.subheading1.neutral.black" color="text_High_Emphasis">
                    {current}
                </CurrentStateText>
                <Text variant="V2.body2.neutral.medium" color="text_High_Emphasis">
                    {next}
                </Text>
                <Text variant="V2.body2.neutral.regular" color="text_Low_Emphasis">
                    {nextAlt}
                </Text>
            </TimelineContent>
        </TimelineContainer>
    );
}

export default memo(AutopayTimelineContent);
